/* Dependencies */
import styled from 'styled-components';

/* Components */
import { Modal } from 'lego-dist';

export const ModalView = styled(Modal).attrs(() => ({
  className: '',
}))`

  ${({ theme }) => theme.breakPoints.mobile} {
    height: 100vh;
    .Container {
      height: calc(100% - 60px);
      .ButtonGroup {
        margin-top: auto;
      }
    }
  }
  ${({ theme }) => theme.breakPoints.tablet} {
    height: auto;
    .Container {
      height: auto;
      .ButtonGroup {
        margin-top: auto;
      }
    }
  }
`;

export const SelectExportCentersContainer = styled.div.attrs(() => ({
  className: 'Container',
}))`
  padding: 24px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  *:not(b, button) {
    color: #4A4A4A;
  }
`;

export const LabelTitle = styled.h5<any>`
  font-family: "Proxima Nova";
  font-size: 20px;
  margin-top: 0;
  margin-bottom: 12px;
  text-align: ${({ center }: any) => center ? 'center' : 'left'}}
`;

export const LabelSection = styled.h6`
  font-family: "Proxima Nova";
  font-size: 18px;
  margin: 0 0 8px 0;
`;

export const ModalDescription = styled.p`
  font-family: "Proxima Nova";
  font-size: 16px;
  text-align: justify;
  line-height: 1.25;
  margin-bottom: 24px;
  b {
    color: var(--primary-blue);
    text-decoration: underline;
  }
`;

export const ButtonGroup = styled.div<any>`
  display: flex;
  flex-direction: row;
  justify-content: ${({ center }: any) => center ? 'center' : 'flex-end'};}
  button:first-child {
    margin-right: 16px;
  }
  button:only-child {
    margin-right: 0;
  }
  button:active {
    appearance: none;
  }
`;
export const SelecterContainer = styled.div.attrs(() => ({
  className: 'SelecterContainer',
}))`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 32px;
  .legoSelecterContainer {
    ${({ theme }) => theme.breakPoints.mobile} {
      width: 100%;
    }
    ${({ theme }) => theme.breakPoints.tablet} {
      width: 66.67%;
    }

  }
`;
